import 'react';
import { useFullscreenActions } from '@pm2/react-utils';
import { usePm2Modal } from '@pm2/ui-lightbox';
import { componentFrameworkStore } from '@provider/component-framework';
import { InMemoryNavigationProvider } from '@provider/navigation';
import { IArkComponent } from '../../../root.component/_component.js';
import { jsx } from 'react/jsx-runtime';

function useIArkFullscreenActions(args) {
  const pm2Modal = usePm2Modal();
  return useFullscreenActions({
    ...args,
    onFullscreenOpen: () => {
      componentFrameworkStore.dispatch(componentFrameworkStore.actions.activateComponent(args.componentProps.node.component.envelope.ID));
    },
    handleOpenInLightboxFallback: () => {
      if (args.componentProps.context === "embedded") {
        args.componentProps.openInLightbox();
      } else {
        pm2Modal.fromComponentFrameworkNode(/*#__PURE__*/jsx(InMemoryNavigationProvider, {
          initialPath: location.pathname,
          children: /*#__PURE__*/jsx(IArkComponent, {
            ...args.componentProps,
            context: "lightbox"
          })
        }), "component-framework.i-ark");
      }
    }
  });
}

export { useIArkFullscreenActions };
//# sourceMappingURL=useFullscreenActions.js.map
